import { put, call, takeEvery, select } from 'redux-saga/effects';
import { getPriceByUrl } from 'yoda-interfaces/lib/Product/ProductPricingApi';
import { X_CLIENT_SOURCE_PDP } from 'yoda-site-components/lib/common/Constants';
import { getDisableBYDeliveryDateFlag } from 'yoda-site-components/lib/selectors/byDeliveryDateSelector';
import {
    BUNDLE_ITEMOFFERING_GET_SUCCESS,
    BUNDLE_ITEMOFFERING_GET_ERROR,
    BUNDLE_ITEMOFFERING_GET_REQUEST,
} from '../actionTypes/BundleItemOfferingActionTypes';

function* bundleItemOfferingSaga(item) {
    try {
        const disableBYDeliveryDate = yield select(getDisableBYDeliveryDateFlag);
        const offering = yield call(getPriceByUrl, {
            url: item.payload.url,
            params: item.payload.params,
            xClientSource: !disableBYDeliveryDate ? X_CLIENT_SOURCE_PDP : null,
        });
        yield put({
            type: BUNDLE_ITEMOFFERING_GET_SUCCESS,
            payload: { ppId: item.payload.id, itemOffering: offering },
        });
    } catch (error) {
        yield put({ type: BUNDLE_ITEMOFFERING_GET_ERROR, error });
    }
}

const watchProductPricingRequest = function* watchProductPricingRequest() {
    yield takeEvery(BUNDLE_ITEMOFFERING_GET_REQUEST, bundleItemOfferingSaga);
};

watchProductPricingRequest.sagaName = 'productPricingRequest';

export default watchProductPricingRequest;
